import React, { useState } from 'react';
import { EmailPreviewFrame } from './EmailEditor';
import useCampaignSnapshot from '../useCampaignSnapshot';
import MetricValues from '../MetricValues';

const Row = ({ label, children }) => (
  <div className='flex gap-4 py-2 border-b border-slate-100 last:border-0'>
    <div className='w-40 shrink-0 text-xs uppercase tracking-wide text-slate-500 pt-0.5'>{label}</div>
    <div className='flex-1 text-sm text-slate-900'>{children}</div>
  </div>
);

// Details email-кампании: параметры рассылки и итоги по статусам провайдера.
const EmailCampaignDetails = ({ campaign:initial }) => {
  const {snapshot,error}=useCampaignSnapshot(initial.id,{metric_catalog:initial.metric_catalog});
  const campaign={...initial,metric_catalog:snapshot.metric_catalog || initial.metric_catalog};
  const [showEmail, setShowEmail] = useState(false);
  const [device, setDevice] = useState('desktop');
  const e = campaign.email || {};
  const s = e.stats || {};

  return (
    <div className='space-y-6'>
      {error && <p role='alert'>{error}</p>}
      <MetricValues metrics={campaign.metric_catalog?.filter((metric) => !['depositors','deposits_count','deposit_sum','avg_deposit','median_deposit','median_deposits_count','median_deposit_sum','conversion_rate'].includes(metric.key))} />
      <p className='text-xs text-slate-500'>Recipients: {s.recipients ?? '—'} · Pending: {s.pending ?? '—'} · Sending errors: {s.failed ?? '—'}</p>
      <p className='text-xs text-slate-400 -mt-3'>
        Opens are approximate: some mail apps (e.g. Apple Mail) load images automatically and count as an open.
      </p>

      <div className='bg-white border border-slate-200 rounded-xl p-5'>
        <div className='flex items-center justify-between mb-2'>
          <h2 className='text-lg font-semibold text-slate-900'>Details</h2>
          <button onClick={() => setShowEmail(!showEmail)} className='text-sm text-blue-600 hover:text-blue-800'>
            {showEmail ? 'Hide email' : 'Show sent email'}
          </button>
        </div>
        <Row label='Channel'>Email</Row>
        <Row label='Email template'>{e.template_name || <span className='text-slate-400'>deleted — the campaign keeps its copy</span>}</Row>
        <Row label='Subject'>
          {e.subject}
          {e.preheader && <span className='block text-xs text-slate-500'>{e.preheader}</span>}
        </Row>
        <Row label='From'>{e.from_name} &lt;{e.from_address}&gt;</Row>
        <Row label='Segments'>{e.segment_names?.join(', ') || e.segment_name || '—'}</Row>
        <Row label='Recipients'>{s.recipients ?? 0}</Row>
        <Row label='Started'>{e.started_at ? new Date(e.started_at).toLocaleString() : campaign.scheduled_at ? `Scheduled for ${new Date(campaign.scheduled_at).toLocaleString()}` : '—'}</Row>
        <Row label='Goal'>{campaign.goal_type === 'deposit' ? 'Deposit' : 'Click (link in the email)'}</Row>
        <Row label='Attribution window'>{campaign.attribution_window_hours}h</Row>
        <Row label='Status'>{campaign.status}</Row>

        {showEmail && (
          <div className='mt-4'>
            <div className='flex justify-end mb-2'>
              <div className='flex bg-slate-100 rounded p-0.5'>
                {['desktop', 'mobile'].map((d) => (
                  <button key={d} onClick={() => setDevice(d)} className={`px-2 py-0.5 text-xs rounded ${device === d ? 'bg-white shadow-sm' : 'text-slate-500'}`}>
                    {d === 'desktop' ? 'Desktop' : 'Mobile'}
                  </button>
                ))}
              </div>
            </div>
            <EmailPreviewFrame html={e.html} device={device} height={700} />
          </div>
        )}
      </div>
    </div>
  );
};

export default EmailCampaignDetails;
